const dataProduct = `
    id
    uid
    type_id
    sku
    name
    first_child_product,
    url_path
    url_key
    labels_sales
    flash_sale
    promotion_image_detail
    promotion_image_list
    product_note
    campaign
    sizeguide
    related_category_id
    related_products {
        id
        uid
        sku
    }
    categories {
        id
        uid
        level
        name
    }
    price_range {
        maximum_price {
            discount {
                amount_off
                percent_off
            }
            final_price {
                value
            }
            regular_price {
                value
            }
        }
        minimum_price {
            discount {
                amount_off
                percent_off
            }
            final_price {
                value
            }
            regular_price {
                value
            }
        }
    }
    image {
        disabled
        label
        position
        url
    }
    description {
        html
    }
    short_description {
        html
    }

    media_gallery_entries {
        disabled
        file
        id
        label
        media_type
        position
        types
        uid
    }
    
    ... on ConfigurableProduct {
        variants {
            attributes {
                code
                label
                uid
            }
            product {
                id
                uid
                sku
                name
                mastercolor
                color
                size
                image {
                    disabled
                    label
                    position
                    url
                }
                media_gallery_entries {
                    disabled
                    file
                    id
                    label
                    media_type
                    position
                    types
                    uid
                }
                price_range {
                    maximum_price {
                        discount {
                            amount_off
                            percent_off
                        }
                        final_price {
                            value
                        }
                        regular_price {
                            value
                        }
                    }
                    minimum_price {
                        discount {
                            amount_off
                            percent_off
                        }
                        final_price {
                            value
                        }
                        regular_price {
                            value
                        }
                    }
                }
            }
        }
        configurable_options {
            attribute_id
            attribute_code
            label
            values {
                label
                uid
                swatch_data {
                    value
                    ... on ImageSwatchData {
                        thumbnail
                        value
                    }
                }
            }
        }
    }        
`;

export const GET_PRODUCTS = `query products(
    $search: String = "", 
    $filter: ProductAttributeFilterInput, 
    $sort: ProductAttributeSortInput, 
    $pageSize: Int = 10, 
    $currentPage: Int = 1) {
    products(search: $search, filter: $filter, sort: $sort, pageSize: $pageSize, currentPage: $currentPage) {
        items {
            ${dataProduct}
        }
        page_info {
            current_page
            page_size
            total_pages
        }
        total_count
    }
}`;

export const GET_PRODUCTS_WITH_AGGREGATIONS = `query products(
    $search: String = "", 
    $filter: ProductAttributeFilterInput, 
    $sort: ProductAttributeSortInput, 
    $pageSize: Int = 10, 
    $currentPage: Int = 1) {
    products(search: $search, filter: $filter, sort: $sort, pageSize: $pageSize, currentPage: $currentPage) {
        items {
            ${dataProduct}
        }
        page_info {
            current_page
            page_size
            total_pages
        }
        total_count
        aggregations {
            attribute_code
            count
            label
            position
            options {
                count
                label
                value
            }
        }
    }
}`;

export const GET_AGGREGATIONS = `query products(
    $search: String = "", 
    $filter: ProductAttributeFilterInput, 
    $sort: ProductAttributeSortInput, 
    $pageSize: Int = 10, 
    $currentPage: Int = 1) {
    products(search: $search, filter: $filter, sort: $sort, pageSize: $pageSize, currentPage: $currentPage) {
        aggregations {
            attribute_code
            count
            label
            position
            options {
                count
                label
                value
            }
        }
    }
}`;

export const GET_PRODUCT_SEARCH = `query productSearch(
    $search: String = "", 
    $filter: ProductAttributeFilterInput, 
    $sort: ProductAttributeSortInput, 
    $pageSize: Int = 10, 
    $currentPage: Int = 1) {
    productSearch(search: $search, filter: $filter, sort: $sort, pageSize: $pageSize, currentPage: $currentPage) {
        items {
            ${dataProduct}
        }
        page_info {
            current_page
            page_size
            total_pages
        }
        total_count
    }
}`;

export const GET_PRODUCT_SEARCH_WITH_AGGREGATIONS = `query productSearch(
    $search: String = "", 
    $filter: ProductAttributeFilterInput, 
    $sort: ProductAttributeSortInput, 
    $pageSize: Int = 10, 
    $currentPage: Int = 1) {
    productSearch(search: $search, filter: $filter, sort: $sort, pageSize: $pageSize, currentPage: $currentPage) {
        aggregations {
            attribute_code
            count
            label
            options {
                count
                label
                value
            }
        }
    }
}`;

// export default {GET_PRODUCTS, GET_PRODUCTS_WITH_AGGREGATIONS};
